import { spawn } from "redux-saga/effects";
import DigipankSaga from "./DigipankSaga";
export function* rootSagas(){
    yield spawn(DigipankSaga)
}